// extracted by mini-css-extract-plugin
export default {"link":"TextWithPopover_link__-1WyI","popover":"TextWithPopover_popover__vBYYW","paper":"TextWithPopover_paper__4ylgd"};